import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSucessResponse } from "../../utils/API/responseMiddleware";


const subSkillAPI = createApi({
    reducerPath: 'subSkillAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        //**  AddEdit API */
        addEditSubSkill: builder.mutation({
            query: (Details) => ({
                url: '/Skill/AddEditSubSkill',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //**  List API */
        getSubSkill: builder.mutation({
            query: (userQuery) => ({
                url: '/Skill/GetSubSkill',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //**  GetByID API */
        getSubSkillBySubSkillId: builder.query({
            query: (subSkillId) => ({
                url: encryptQueryString(`/Skill/GetSubSkillBySubSkillId/?subSkillId=${Number(subSkillId)}`),
                method: 'GET',
            }),
 
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** Delete API */
        deleteSubSkill: builder.mutation({
            query: (subSkillId) => ({
                url: `/Skill/DeleteSubSkill/?subSkillId=${subSkillId}`,
                method: 'DELETE',
                body: transformRequest(subSkillId)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
})

export const {  useAddEditSubSkillMutation,useGetSubSkillMutation,useLazyGetSubSkillBySubSkillIdQuery,useDeleteSubSkillMutation,} = subSkillAPI;

export default subSkillAPI;